import React, { useRef } from 'react'
import AdminHeader from '../../components/AdminHeader/AdminHeader'
import SuperAdminSidebar from '../../components/superadminsidebar/SuperAdminSidebar'
import DashboardSidebarHeader from '../../components/corporateSidebar/DashboardSidebarHeader'
import useDashboardSidebarToggle from '../../hooks/useDashboardSidebarToggle'
import '../../components/AdminStyles/AdminStyles.css'

const AdminDashboardLayout = ({ children }) => {
    const sidebarRef = useRef(null);
    const { sidebarOpen, closeSidebar } = useDashboardSidebarToggle(sidebarRef, 'adminNavbar');

    return (
        <div className="admin-layout">
            <AdminHeader />
            {sidebarOpen && <div className="dashboard-sidebar-backdrop" onClick={closeSidebar}></div>}
            <div className="admin-layout-body">
                <aside
                    ref={sidebarRef}
                    className={`admin-layout-sidebar dashboard-sidebar-col${sidebarOpen ? ' dashboard-sidebar-open' : ''}`}
                >
                    <DashboardSidebarHeader />
                    <SuperAdminSidebar />
                </aside>
                <main className="admin-layout-content">
                    {children}
                </main>
            </div>
        </div>
    )
}

export default AdminDashboardLayout